import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { Environment, Preload} from "@react-three/drei";
import ImageTexture from "./Elements/Image";

const Hero = () => {
  const canvasStyle = {
    position: 'absolute',
    zIndex: '2',
    top: '0'
  }


  return <Canvas style={canvasStyle}>

    {/* Environment and lighting */}
    <ambientLight color={0xffffff} intensity={1}/>

    {/* Set the fallback loading on null */}
      <Suspense fallback={null}>
        <ImageTexture />
      </Suspense>

    {/* Scroll group (HTML assets) */}

    <Preload />
  </Canvas>
}

export default Hero